function currentWindow() {
  return typeof window === 'undefined' ? null : window;
}

function workspaceParent(browserWindow) {
  if (!browserWindow) return null;
  try {
    const parent = browserWindow.parent;
    if (!parent || parent === browserWindow || parent.location.origin !== browserWindow.location.origin) return null;
    const shell = parent.__bankariWorkspaceShell;
    return shell ? { parent, shell } : null;
  } catch {
    // A page embedded by another origin must retain its own navigation.
    return null;
  }
}

function authorizationUrl(value, browserWindow) {
  const url = new URL(value, browserWindow.location.href);
  const facebook = url.host === 'www.facebook.com' && /^\/(?:v\d+\.\d+\/)?dialog\/oauth\/?$/.test(url.pathname);
  const googleCalendar = url.host === 'apire.bankari.sk' && /^\/google-calendar\/connect\/?$/.test(url.pathname);
  if (url.protocol !== 'https:' || url.username || url.password || (!facebook && !googleCalendar)) {
    throw new Error('Neplatná adresa pripojenia účtu.');
  }
  return url.href;
}

export function getWorkspaceReturnUrl(browserWindow = currentWindow()) {
  if (!browserWindow) return '';
  const workspace = workspaceParent(browserWindow);
  return typeof workspace?.shell.prepareExternalNavigation === 'function'
    ? workspace.shell.prepareExternalNavigation(browserWindow)
    : browserWindow.location.href;
}

export function navigateWorkspaceExternal(value, browserWindow = currentWindow()) {
  if (!browserWindow) return false;
  const url = authorizationUrl(value, browserWindow);
  const workspace = workspaceParent(browserWindow);
  if (typeof workspace?.shell.prepareExternalNavigation === 'function') {
    workspace.shell.prepareExternalNavigation(browserWindow);
    workspace.parent.location.assign(url);
  } else {
    browserWindow.location.assign(url);
  }
  return true;
}

export function notifyWorkspaceLogout(browserWindow = currentWindow()) {
  const workspace = workspaceParent(browserWindow);
  if (typeof workspace?.shell.endSession !== 'function') return false;
  return workspace.shell.endSession(browserWindow) !== false;
}
